import { CategoryDetails, ItemDetails, StoreData } from '../../data/store-data';
import React, { useEffect, useMemo, useState } from 'react';
import ListItem from '../../components/list/ListItem';
import { useParams } from 'react-router-dom';

interface Props {
  categories: CategoryDetails[];
}

const List: React.FC<Props> = props => {
  const storeData = useMemo(() => new StoreData(), []);
  const [items, setItems] = useState([] as ItemDetails[]);
  const [category, setCategory] = useState<CategoryDetails>();
  const params = useParams<{ listId: string }>();

  useEffect(() => {
    setCategory(props.categories.find(cat => cat.name === params.listId));
  }, [params.listId, props.categories]);

  useEffect(() => {
    if (!category) return;
    storeData.getItemsByCategory(category.name).then(data => setItems(data));
  }, [category, storeData]);

  return (
    <div className="List">
      {items.map(item => (
        <ListItem key={item.name} item={item} />
      ))}
    </div>
  );
};

export default List;
